"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteLineStatus = void 0;
var RequestForQuoteLineStatus;
(function (RequestForQuoteLineStatus) {
    RequestForQuoteLineStatus["NEW"] = "new";
    RequestForQuoteLineStatus["ASSIGNED"] = "assigned";
    RequestForQuoteLineStatus["IN_PROCESS"] = "in-process";
    RequestForQuoteLineStatus["AWAITING_RESPONSE"] = "awaiting-response";
    RequestForQuoteLineStatus["DONE"] = "done";
})(RequestForQuoteLineStatus = exports.RequestForQuoteLineStatus || (exports.RequestForQuoteLineStatus = {}));
//# sourceMappingURL=request-for-quote-line-status.enum.js.map